export default "__VITE_ASSET__0f6f6bdf__"